export const PHONE_PATTERN_SIMPLE = /^[-+\d() ]{4,}$/
const PHONE_MIN_NUMBER_OF_DIGITS = 4

export function validatePhone(input: string) {
  const withoutFormatting = input.replaceAll(/[-+() ]/g, "")
  const isNumerical = withoutFormatting.match(/^\d+$/g)

  return isNumerical && withoutFormatting.length >= PHONE_MIN_NUMBER_OF_DIGITS
}
